import { format } from "date-fns";
import { ArrowLeft, Calendar } from "lucide-react";
import React from "react";
import PropTypes from 'prop-types';
import { Col, Row } from "react-bootstrap";

const ClientProgramHeader = ({
  selectedDate,
  programName,
  onBack,
  isPreview = false,
}) => {
  return (
    <div className="mb-4">
      <Row className="align-items-center mb-2">
        <Col>
          <div className="d-flex align-items-center">
            <button
              className="d-flex align-items-center border-0 bg-transparent p-0 me-3"
              onClick={() => {
                if (onBack) {
                  onBack();
                  return;
                }
                window.history.back();
              }}
              style={{ color: '#FF69B4' }}
              aria-label={isPreview ? "Exit client preview" : "Go back"}
            >
              <ArrowLeft size={24} />
            </button>
            <Calendar
              size={20}
              className="me-2 text-dark"
            />
            <h6 className="mb-0 mt-1">
              {format(new Date(selectedDate), "EEEE, MMMM d, yyyy")}
            </h6>
          </div>
        </Col>
      </Row>
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <h2 className="mb-0">{programName}</h2>
        {isPreview && (
          <span className="badge bg-light text-dark border">
            Client preview · read only
          </span>
        )}
      </div>
    </div>
  );
};
ClientProgramHeader.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  programName: PropTypes.string.isRequired,
  onBack: PropTypes.func,
  isPreview: PropTypes.bool,
};

export default ClientProgramHeader;
